import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    SplunkPassport,
    SplunkLoadState,
    SplunkPassportFormState,
    SplunkPassportID,
    SplunkPassportHeader,
    initSplunkPassport,
    SplunkDashboard,
} from "userful-chronos-app-common-js/dist/models/integration/splunk";
import {
    requestListPassports,
    requestAddPassport,
    requestRemovePassport,
    requestUpdatePassport,
    requestListDashboards,
} from "./msgs/splunkMsgSender";

const initialState: {
    splunkPassports: SplunkPassport[];
    loadState: SplunkLoadState;
    passport: SplunkPassport;
    copyPassport: SplunkPassport;
    formType: SplunkPassportFormState;
    openForm: boolean;
    splunkDashboards: SplunkDashboard[];
} = {
    splunkPassports: [],
    loadState: "RENDER",
    passport: initSplunkPassport(),
    copyPassport: initSplunkPassport(),
    formType: "Create",
    openForm: false,
    splunkDashboards: [],
};

export const splunkSlice = createSlice({
    name: "splunkSlice",
    initialState,
    reducers: {
        setPassports: (state, action: PayloadAction<SplunkPassport[]>) => {
            state.splunkPassports = action.payload;
        },
        addOrUpdatePassport: (state, action: PayloadAction<SplunkPassport>) => {
            const foundIndex = state.splunkPassports.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex < 0) {
                state.splunkPassports = [...state.splunkPassports, { ...action.payload }];
            } else {
                state.splunkPassports = [
                    ...state.splunkPassports.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.splunkPassports.slice(foundIndex + 1),
                ];
            }
        },
        removePassport: (state, action: PayloadAction<SplunkPassportID>) => {
            state.splunkPassports = state.splunkPassports.filter((item) => item.id.value !== action.payload.value);
        },
        getPassportsFromServer: (state, action: PayloadAction<{}>) => {
            requestListPassports();
        },
        addPassportToServer: (state, action: PayloadAction<SplunkPassportHeader>) => {
            requestAddPassport(action.payload);
        },
        updatePassportToServer: (state, action: PayloadAction<SplunkPassportHeader>) => {
            requestUpdatePassport(action.payload);
        },
        removePassportToServer: (state, action: PayloadAction<SplunkPassportID>) => {
            requestRemovePassport(action.payload);
        },
        changeLoadState: (state, action: PayloadAction<SplunkLoadState>) => {
            state.loadState = action.payload;
        },
        setPassport: (state, action: PayloadAction<SplunkPassport>) => {
            state.passport = action.payload;
        },
        setCopyPassport: (state, action: PayloadAction<SplunkPassport>) => {
            state.copyPassport = action.payload;
        },
        setFormType: (state, action: PayloadAction<SplunkPassportFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
        requestDashboards: (state, action: PayloadAction<SplunkPassportID>) => {
            requestListDashboards(action.payload);
        },
        setDashboards: (state, action: PayloadAction<SplunkDashboard[]>) => {
            state.splunkDashboards = action.payload;
        },
    },
});

export const splunkActions = splunkSlice.actions;

export default splunkSlice.reducer;
